<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">添加费用折扣</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="addForm" :rules="rules" ref="addForm">
                    <div>
                        <el-row>
                            <el-col :span="24" class="item">
                                    <el-col :span="12" class="item">
                                        <el-form-item label="折扣名称"  required prop="name">
                                            <el-input v-model="addForm.name" placeholder="请输入折扣名称"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12" class="item">
                                        <el-form-item label="折扣类型"  required prop="discountType">
                                            <el-select v-model="addForm.discountType" placeholder="请选择" style="width:100%">
                                                <el-option
                                                v-for="item in discountTypeValue"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12" class="item">
                                        <el-form-item label="折扣率%(0-100以内的数字保留两位小数)"  required prop="discount">
                                            <el-input-number v-model="addForm.discount" :min='0' :max="99.99" :precision="2" placeholder="请输入折扣" :controls='false' class="inputMoneyNumber" style="width:100%;"></el-input-number>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12" class="item">
                                        <el-form-item label="折扣率2" prop="discount2">
                                            <el-input-number v-model="addForm.discount2" :min='0' :max="99.99" :precision="2" placeholder="请输入折扣" :controls='false' class="inputMoneyNumber" style="width:100%;"></el-input-number>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12" class="item">
                                        <el-form-item label="折扣率3" prop="discount3">
                                            <el-input-number v-model="addForm.discount3" :min='0' :max="99.99" :precision="2" placeholder="请输入折扣" :controls='false' class="inputMoneyNumber" style="width:100%;"></el-input-number>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12" class="item">
                                        <el-form-item label="折扣率4" prop="discount4">
                                            <el-input-number v-model="addForm.discount4" :min='0' :max="99.99" :precision="2" placeholder="请输入折扣" :controls='false' class="inputMoneyNumber" style="width:100%;"></el-input-number>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12" class="item">
                                        <el-form-item label="折扣率5" prop="discount5">
                                            <el-input-number v-model="addForm.discount5" :min='0' :max="99.99" :precision="2" placeholder="请输入折扣" :controls='false' class="inputMoneyNumber" style="width:100%;"></el-input-number>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12" class="item">
                                        <el-form-item label="是否审核"  required prop="needVerify">
                                            <el-radio-group v-model="addForm.needVerify"  style="width:100%">
                                                <el-radio :label=0>不需要</el-radio>
                                                <el-radio :label=1>需要</el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </el-col>
                                    
                            </el-col>
                        </el-row>
                        <!-- <el-row>
                            <el-col :span="24" class="item">
                                <el-col :span="12" class="item">
                                        <el-form-item label="折扣开始日期"  required prop="startTime">
                                            <el-date-picker
                                                v-model="addForm.startTime"
                                                type="datetime"
                                                default-time="00:00:00"
                                                style="width:100%;"
                                                value-format="yyyy-MM-dd HH:mm:ss"
                                                placeholder="折扣开始日期">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12" class="item">
                                        <el-form-item label="折扣结束日期"  required prop="endTime">
                                            <el-date-picker
                                                v-model="addForm.endTime"
                                                type="datetime"
                                                default-time="23:59:59"
                                                style="width:100%;"
                                                value-format="yyyy-MM-dd HH:mm:ss"
                                                placeholder="折扣结束日期">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                </el-col>
                        </el-row> -->
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode,getChargeTime} from "@/utils/auth";


    export default {
        name: 'Add',
        data() {
             //自定义校验规则
            return {
                loading: false,
                chargeTime:'',
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    name:'',
                    discount:undefined,
                    discount2:undefined,
                    discount3:undefined,
                    discount4:undefined,
                    discount5:undefined,
                    discountType:'',
                    needVerify:'',
                    // startTime:'',
                    // endTime:''
                },
                discountTypeValue:[{
                    value: 'room',
                    label: '床位折扣'
                }, {
                    value: 'nursing',
                    label: '护理等级折扣'
                }, {
                    value: 'other',
                    label: '自添加项目折扣'
                }, {
                    value: 'all',
                    label: '总费用折扣'
                }],
                rules:{
                    discount:[
                        { required: true, message: '请输入折扣', trigger: 'blur' },
                    ],
                    discount2:[],
                    discount3:[],
                    discount4:[],
                    discount5:[],
                    name:[
                        { required: true, message: '请输入折扣名称', trigger: 'blur' },
                    ],
                    discountType:[
                        { required: true, message: '请选择折扣类型', trigger: 'blur' },
                    ],
                    needVerify:[
                        { required: true, message: '请选择是否审核', trigger: 'blur' },
                    ],
                    // startTime:[
                    //     { required: true, message: '请选择开始时间', trigger: 'blur' },
                    // ],
                    // endTime:[
                    //     { required: true, message: '请选择结束时间', trigger: 'blur' },
                    // ],
                    
                }
            }
        },
        created(){
            this.chargeTime = getChargeTime();
        },
        methods: {
            init(){
                this.$refs.addForm.resetFields();
            },
            closeSelf() {
                this.$emit("closeAdd");
            },
            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        this.addSubmit(addForm);
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },

            addSubmit(addForm){
                this.loading = true;
                var data=JSON.parse(JSON.stringify(this.addForm))
                data.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                for(var i=0;i<5;i++){
                    var name=i>0?'discount'+(i+1):'discount'
                    data[name]=data[name]?data[name]*100:0
                }
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"InstitutionDiscount/Add",
                    data: data
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$refs[addForm].resetFields();
                            this.$emit("closeAdd");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 800px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .box-card{
                margin: 10px 0;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                overflow-y: auto;
                .inputMoneyNumber /deep/ .el-input__inner{
                    text-align: left;
                }
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
